"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gav = exports.basicVersionGroupProperties = exports.basicAssetProperties = exports.assetProperties = exports.assetDownloadProperties = exports.SEARCHED_IN_PORTAL = exports.OPENED_PORTAL_SEARCH = exports.NEW_VERSION_ADDED = exports.NAVIGATED_PORTAL_SEARCH_MATCHES = exports.EVENT_TYPES = exports.CLOSED_PORTAL_SEARCH = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var basicAssetProperties = exports.basicAssetProperties = ['organizationId', 'groupId', 'assetId', 'version', 'name', 'type', 'originalFormat', 'originalFormatVersion'];
var basicVersionGroupProperties = exports.basicVersionGroupProperties = ['organizationId', 'groupId', 'assetId', 'versionGroup', 'type'];
var gav = exports.gav = ['groupId', 'assetId', 'version'];
var NEW_VERSION_ADDED = exports.NEW_VERSION_ADDED = {
  name: 'New version added',
  required: basicAssetProperties
};
var ASSET_DEPENDENCY_CLICKED = 'Asset dependency clicked';
var assetProperties = exports.assetProperties = function assetProperties(_ref) {
  var asset = _ref.asset;
  return {
    organizationId: asset.organization.id,
    groupId: asset.groupId,
    assetId: asset.assetId,
    version: asset.version,
    name: asset.name,
    type: asset.type,
    originalFormat: asset.originalFormat,
    originalFormatVersion: asset.originalFormatVersion
  };
};
var assetDownloadProperties = exports.assetDownloadProperties = function assetDownloadProperties(_ref2) {
  var asset = _ref2.asset,
    file = _ref2.file;
  return _objectSpread(_objectSpread({}, assetProperties({
    asset: asset
  })), {}, {
    classifier: file.classifier
  });
};
var VERSION_DROPDOWN_CLICKED = {
  name: 'Version dropdown clicked',
  required: ['organizationId', 'groupId', 'assetId', 'type']
};
var SEARCHED_IN_PORTAL = exports.SEARCHED_IN_PORTAL = {
  name: 'Searched within portal',
  required: [].concat(gav, ['term', 'resultsCount'])
};
var NAVIGATED_PORTAL_SEARCH_MATCHES = exports.NAVIGATED_PORTAL_SEARCH_MATCHES = {
  name: 'Navigated between portal search matches',
  required: [].concat(gav, ['type'])
};
var OPENED_PORTAL_SEARCH = exports.OPENED_PORTAL_SEARCH = {
  name: 'Opened portal search',
  required: gav
};
var CLOSED_PORTAL_SEARCH = exports.CLOSED_PORTAL_SEARCH = {
  name: 'Closed portal search',
  required: gav
};
var EVENT_TYPES = exports.EVENT_TYPES = {
  ASSET_DEPENDENCY_CLICKED: ASSET_DEPENDENCY_CLICKED,
  NEW_VERSION_ADDED: NEW_VERSION_ADDED,
  VERSION_DROPDOWN_CLICKED: VERSION_DROPDOWN_CLICKED,
  SEARCHED_IN_PORTAL: SEARCHED_IN_PORTAL,
  NAVIGATED_PORTAL_SEARCH_MATCHES: NAVIGATED_PORTAL_SEARCH_MATCHES,
  OPENED_PORTAL_SEARCH: OPENED_PORTAL_SEARCH,
  CLOSED_PORTAL_SEARCH: CLOSED_PORTAL_SEARCH
};
//# sourceMappingURL=events.js.map